import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import { STATIC_CMS_ROOT } from '../../constants';

import { getMerchantCardUrl } from '../../services/partner/utils';
import { getBilletterieMerchantUrl } from '../../services/billetterie/utils';
import { isBilletteriePartner } from '../../services/billetterie/selector';

import LocalizedNavLink from '../router/LocalizedNavLink';
import PartnerBlockComponent from '../partner/PartnerBlockComponent';

class ItemCarrouselComponent extends React.Component {
    constructor(props) {
        super(props);
        this.itemRef = React.createRef();
        this.state = { loaded: false };
    }

    componentDidMount() {
        // Be sure that the ref {itemRef} has been rendered on the DOM before displaying the content,
        // to ensure tabIndex has been correctly set
        this.setState({ loaded: true });
    }

    renderPicture() {
        const { i18n, partner, isOffline, isEbon, item } = this.props;

        const title =
            partner && partner.name
                ? `${isEbon ? i18n.jachete : isOffline ? i18n.discover : i18n.jenprofite} : ${
                      partner.name
                  }`
                : '';
        const isImageFocusable = !partner && item.titre;

        return (
            <picture>
                <source
                    srcSet={`${STATIC_CMS_ROOT}/carousel/${item.image2}`}
                    media="(max-width: 768px)"
                />
                <img
                    src={`${STATIC_CMS_ROOT}/carousel/${item.image}`}
                    alt={item.titre || title}
                    className="background-picture"
                    tabIndex={isImageFocusable ? this.getTabIndex() : undefined}
                />
            </picture>
        );
    }

    renderContionnalPictureContainer = () => {
        const { partner, isOffline, isEbon, isBilletterie, item } = this.props;

        if (!partner) {
            const urlMea = item.tracking;

            if (urlMea) {
                return (
                    <a href={urlMea} className="background-picture" tabIndex={this.getTabIndex()}>
                        {this.renderPicture()}
                    </a>
                );
            } else {
                return this.renderPicture();
            }
        } else if (isEbon && isBilletterie) {
            // Fiche billetterie servie par une autre application : lien hors routeur
            return (
                <a
                    href={getBilletterieMerchantUrl(partner)}
                    className="background-picture"
                    tabIndex={this.getTabIndex()}>
                    {this.renderPicture()}
                </a>
            );
        } else {
            const urlMea = getMerchantCardUrl(partner, isOffline, isEbon);

            return (
                <LocalizedNavLink
                    to={urlMea}
                    className="background-picture"
                    tabIndex={this.getTabIndex()}>
                    {this.renderPicture(item)}
                </LocalizedNavLink>
            );
        }
    };

    getTabIndex = () => {
        if (this.itemRef.current) {
            const parentAttributes = this.itemRef.current.parentNode.parentNode.attributes;
            return parentAttributes[3].nodeValue === 'true' ? -1 : 0;
        }
    };

    render() {
        const { partner, item, isOffline, isEbon, noPicture } = this.props;
        const { loaded } = this.state;

        if (!item) {
            return null;
        }

        return (
            <div className="item" ref={this.itemRef}>
                {loaded ? (
                    <React.Fragment>
                        {!noPicture && this.renderContionnalPictureContainer()}
                        {partner && (
                            <PartnerBlockComponent
                                partner={partner}
                                isOffline={isOffline}
                                isEbon={isEbon}
                                tabIndex={this.getTabIndex()}
                            />
                        )}
                    </React.Fragment>
                ) : null}
            </div>
        );
    }
}

ItemCarrouselComponent.propTypes = {
    item: PropTypes.object.isRequired,
    partner: PropTypes.object,
    noPicture: PropTypes.bool,
    isOffline: PropTypes.bool,
    isEbon: PropTypes.bool
};

function mapStateToProps(state, ownProps) {
    return {
        i18n: state.i18n.feature.partenaire,
        isBilletterie: isBilletteriePartner(state, ownProps.partner && ownProps.partner.id)
    };
}

export default connect(mapStateToProps)(ItemCarrouselComponent);



// WEBPACK FOOTER //
// ./src/components/carousel/ItemCarrouselComponent.js